import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Row, Select, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import CustomModal from '../../common/modals/CustomModal';
import { getIdMap } from '../../helpers/helpers';
import OnTraccrButton from '../../common/buttons/OnTraccrButton';
import { saveCompanySettings } from '../../settings/state/settings.actions';

const MODE_OPTIONS = [
  {
    value: 'override',
    label: 'Override',
  },
  // {
  //   value: 'add',
  //   label: 'Append/Add',
  // },
  // {
  //   value: 'subtract',
  //   label: 'Subtract',
  // },
];

const validFieldTypes = new Set(['text', 'attribute']);

export default function ProjectAddFromBucketSettingsModal({
  visible,
  onClose,
}) {
  const dispatch = useDispatch();

  const { settings = {} } = useSelector((state) => state.settings.company);
  const equipmentTypes = useSelector((state) => state.equipment.equipmentTypes);

  const [equipmentType, setEquipmentType] = useState(null);
  const [mode, setMode] = useState('override');
  const [customField, setCustomField] = useState(null);

  useEffect(() => {
    if (visible && settings?.addFromBucket) {
      const {
        equipmentType: equipmentTypeSetting,
        mode: modeSetting,
        customField: customFieldSetting,
      } = settings.addFromBucket;
      setEquipmentType(equipmentTypeSetting);
      setMode(modeSetting);
      setCustomField(customFieldSetting);
    } else {
      setEquipmentType(null);
      setMode('override');
      setCustomField(null);
    }
  }, [visible, settings]);

  const onEquipmentTypeChange = useCallback((value) => {
    setEquipmentType(value);
    setCustomField(null);
  }, []);

  const onSave = useCallback(async () => {
    await dispatch(saveCompanySettings({
      addFromBucket: {
        equipmentType,
        mode,
        customField,
      },
    }));
    onClose();
  }, [equipmentType, mode, customField]);

  const equipmentTypeMap = useMemo(() => getIdMap(equipmentTypes), [equipmentTypes]);
  const relevantCustomFields = useMemo(() => {
    const relevantType = equipmentTypeMap[equipmentType];
    if (!relevantType) return [];
    const fields = [];
    relevantType.customFields?.sections?.forEach(({ fields: sectionFields = [] }) => {
      sectionFields?.forEach((field) => {
        if (validFieldTypes.has(field.type)) {
          fields.push({
            label: field.title,
            value: field.id,
          });
        }
      });
    });
    return fields;
  }, [equipmentType, equipmentTypeMap]);

  const equipmentTypeOptions = equipmentTypes.map((type) => ({
    label: type.name,
    value: type.id,
  }));

  return (
    <CustomModal
      title="Project Add From Bucket Settings"
      visible={visible}
      onCloseClicked={onClose}
    >
      <Row justify="center">
        <Form.Item label="Equipment Type">
          <Select
            style={{ width: 200 }}
            options={equipmentTypeOptions}
            onChange={onEquipmentTypeChange}
            value={equipmentType}
          />
        </Form.Item>
        <Form.Item label="Mode">
          <Select
            style={{ width: 200 }}
            options={MODE_OPTIONS}
            onChange={setMode}
            value={mode}
          />
        </Form.Item>
        <Form.Item label="Custom Field to Update">
          <Select
            style={{ width: 200 }}
            options={relevantCustomFields}
            onChange={setCustomField}
            value={customField}
          />
        </Form.Item>
        <OnTraccrButton
          onClick={onSave}
          type="primary"
          title="Save"
          disabled={!equipmentType || !mode || !customField}
        />
      </Row>
    </CustomModal>
  );
}
